export const SUPPORTED_LANGUAGES = ['ru', 'en', 'uz', 'tg', 'ky', 'az', 'hy', 'kk', 'hi', 'it', 'ro'];
export const DEFAULT_FALLBACK_LANGUAGE = 'en';
export const BACKEND_PERSISTED_LANGUAGES = ['ru', 'en', 'uz', 'tg', 'ky', 'az', 'hy'];
const SUPPORTED_LANGUAGES_SET = new Set(SUPPORTED_LANGUAGES);
const BACKEND_PERSISTED_LANGUAGES_SET = new Set(BACKEND_PERSISTED_LANGUAGES);
function toSupportedLanguageOrNull(locale) {
    if (!locale)
        return null;
    const normalized = locale.trim().toLowerCase().replace(/_/g, '-');
    if (!normalized)
        return null;
    const [language] = normalized.split('-');
    return isSupportedLanguage(language) ? language : null;
}
export function isSupportedLanguage(value) {
    return typeof value === 'string' && SUPPORTED_LANGUAGES_SET.has(value);
}
export function isBackendPersistedLanguage(value) {
    return typeof value === 'string' && BACKEND_PERSISTED_LANGUAGES_SET.has(value);
}
export function normalizeLocaleToLanguage(locale) {
    return toSupportedLanguageOrNull(locale) ?? DEFAULT_FALLBACK_LANGUAGE;
}
function asLocaleList(value) {
    if (typeof value === 'string' || value == null)
        return [value];
    return [...value];
}
export function resolveInitialLanguage(options) {
    const fallbackLanguage = options.fallbackLanguage ?? DEFAULT_FALLBACK_LANGUAGE;
    const candidates = [
        options.savedLanguage,
        ...asLocaleList(options.platformLocale),
        ...asLocaleList(options.browserLocale),
    ];
    for (const candidate of candidates) {
        if (!candidate)
            continue;
        const normalized = toSupportedLanguageOrNull(candidate);
        if (normalized)
            return normalized;
    }
    return fallbackLanguage;
}
/** Parse Accept-Language header tokens in priority order (without q weights). */
export function parseAcceptLanguageHeader(header) {
    if (!header?.trim())
        return [];
    const tokens = [];
    for (const part of header.split(',')) {
        const language = part.trim().split(';')[0]?.trim();
        if (language)
            tokens.push(language);
    }
    return tokens;
}
/** Resolve session/UI language from standard Accept-Language header. */
export function resolveLanguageFromAcceptLanguage(header, options) {
    const fallbackLanguage = options?.fallbackLanguage ?? DEFAULT_FALLBACK_LANGUAGE;
    for (const token of parseAcceptLanguageHeader(header)) {
        const normalized = normalizeLocaleToLanguage(token);
        if (isSupportedLanguage(normalized))
            return normalized;
    }
    return fallbackLanguage;
}
//# sourceMappingURL=locale.js.map